export const getStyliticsBrand = (brand, siteRegion) => {
  const brandMap = {
    anf: 'abercrombie',
    kids: 'abercrombie',
    hol: 'hollister',
    gh: 'hollister',
    st: 'hollister',
  };

  let tempBrand = brandMap[brand] || '';
  if (siteRegion === 'UK') {
    tempBrand += '_uk';
  } else if (siteRegion === 'EU') {
    tempBrand += '_eu';
  }
  return tempBrand;
};

export const styliticsBrandToThemeBrand = {
  ANF: 'anf',
  'HCo.': 'hol',
  'ANF-Kids': 'kids',
  Glh: 'gh',
  st: 'st',
};

export const checkHasShowStyliticsEnabled = (
  showStyliticsFromFeatureSwitch,
  brand,
  isMobile,
) => showStyliticsFromFeatureSwitch && !(brand === 'anf' && isMobile);
